import React, { useRef } from "react";
import "./Features.scss";
import Carousel from "./Carousel";
import FeatureTexts from "./FeatureTexts";

//image imports
import HouseImage from "../../../assets/images/RentlyHouse.webp";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useGSAP } from "@gsap/react";

export default function Features() {
  const imageContainerRef = useRef(null);
  const contentRef = useRef(null);
  const isMobileScreen = () => window.innerWidth <= 768;

  useGSAP(() => {
    const isMobile = window.innerWidth <= 768;

    // // Set initial scale and opacity for image container
    // if (imageContainerRef.current) {
    //   imageContainerRef.current.style.transform = "scale(0)";
    //   imageContainerRef.current.style.opacity = "0";
    //   // imageContainerRef.current.style.filter = "blur(10px)";
    // }

    // Animate image scale on scroll
    gsap.to(imageContainerRef.current, {
      transform: "scale(1)",
      opacity: 1,
      // filter: "blur(0px)",
      ease: "power2.out",
      delay: isMobile ? 0 : 7, // Reduced delay for mobile
      duration: isMobile ? 3 : 10, // Faster animation for mobile
      scrollTrigger: {
        trigger: contentRef.current,
        start: isMobile ? "top 1.1" : "top 18%",
        end: isMobile ? "+=150" : "+=700", // Shorter scroll distance for mobile
        scrub: isMobile ? 1 : 2, // Faster scrub for mobile
        anticipatePin: 1,
        preventOverlaps: true,
        fastScrollEnd: true,
      },
    });

    ScrollTrigger.create({
      trigger: contentRef.current,
      start: isMobileScreen() ? "top top" : "top 18%",
      end: "bottom -100%",
      pin: contentRef.current,
      preventOverlaps: true,
      fastScrollEnd: true,
    });
  }, []);

  return (
    <div className="features-page" id={"about"}>
      <Carousel />
      <div className="content" ref={contentRef}>
        <FeatureTexts Container={contentRef} />
        <div
          className="image-container"
          ref={imageContainerRef}
          // Ensure initial style for scale and opacity
          style={{ transform: "scale(0)", opacity: 0, }}
        >
          <img
            src={HouseImage}
            alt="Rently House"
            className="house-image"
            loading={"lazy"}
            decoding="async"
          />
        </div>
      </div>
    </div>
  );
}
